// --- Dependencies -------------------------------------------------------------------------------
import { useNavigate } from "react-router-dom";
// --- Our Modules --------------------------------------------------------------------------------
import useAuth from "@/hooks/useAuth";
import useStore from "@/hooks/useStore";
import useTranslation from "@/hooks/useTranslation";
import DashboardLayout from "@/UI/components/DashboardLayout";
import "./styles.css";

// --- Logic --------------------------------------------------------------------------------------

function NotFoundContent() {
    const t = useTranslation();
    const navigate = useNavigate();

    return (
        <div className="not-found-content">
            <p className="not-found-code">404</p>
            <div className="not-found-divider" />
            <div className="not-found-text">
                <h1 className="not-found-title">{t.notFound.title}</h1>
                <p className="not-found-subtitle">{t.notFound.subtitle}</p>
            </div>
            <button type="button" className="not-found-btn" onClick={() => navigate("/")}>
                {t.notFound.backButton}
            </button>
        </div>
    );
}

export default function NotFoundScreen() {
    const token = useAuth((state) => state.token);
    const storeId = useStore((state) => state.storeId);

    if (token && storeId) {
        return (
            <DashboardLayout>
                <div className="not-found-wrapper">
                    <NotFoundContent />
                </div>
            </DashboardLayout>
        );
    }

    return (
        <div className="not-found-screen">
            <img className="not-found-logo" src="/logo-mini-round.svg" alt="Menuket" />
            <NotFoundContent />
        </div>
    );
}
